import { Tasks } from '../../../../utils/types';
import { generateAcceptedTaskEmail } from '../../../../email-templates/acceptedTask';

export const handleAcceptedStatus = async (task: Tasks, address: string) => {
  const emailContent = generateAcceptedTaskEmail({
    task: task,
    address: address,
  });
  const subject = '¡Tu Task ha sido aprobada!';

  return { emailContent, subject };
};
